import moment from 'moment'

class GroupAndFormatHours {
  constructor(operationalHours) {
    this.operationalHours = operationalHours
  }

  call() {
    if (!this.operationalHours || !Object.keys(this.operationalHours).length) {
      return [];
    }

    if (this.operationalHours.open24Hours) {
      return [{ days: 'Mon-Sun', hours: '24hr' }];
    }

    return this.formatGroupedHours();
  };

  formatGroupedHours() {
    return this.groupCommonHours().map(({ days, hours }) => {
      const { daysText, hoursText } = this.formatGroup({ days, hours });
      return { days: daysText, hours: hoursText };
    });
  };


  groupCommonHours() {
    return this.openHours().reduce((prevGroups, { day, hours }) => {
      return this.prevGroupHasSameHours(prevGroups, hours)
        ? this.updatePrevGroupsHours(prevGroups, day)
        : [...prevGroups, { days: [day], hours }]
    }, [])
  };

  formatGroup({ days, hours }) {
    const firstDay = [...days].shift();
    const lastDay = [...days].pop();

    const daysText = firstDay === lastDay
          ? firstDay
          : `${firstDay}-${lastDay}`;
    const hoursText = hours.closed
          ? 'Closed'
          : `${this.formatTime(hours.startHr)}-${this.formatTime(hours.endHr)}`;

    return { daysText, hoursText };
  }

  openHours() {
    return [
      { day: 'Mon', hours: this.operationalHours.mondayHrs || this.operationalHours.monToFriHrs },
      { day: 'Tue', hours: this.operationalHours.tuesdayHrs || this.operationalHours.monToFriHrs },
      { day: 'Wed', hours: this.operationalHours.wednesdayHrs || this.operationalHours.monToFriHrs },
      { day: 'Thu', hours: this.operationalHours.thursdayHrs || this.operationalHours.monToFriHrs },
      { day: 'Fri', hours: this.operationalHours.fridayHrs || this.operationalHours.monToFriHrs },
      { day: 'Sat', hours: this.operationalHours.saturdayHrs },
      { day: 'Sun', hours: this.operationalHours.sundayHrs },
    ]
  }

  prevGroupHasSameHours(groups, currentHours) {
    const prevGroup = [...groups].pop();
    return prevGroup && this.sameHours(prevGroup.hours, currentHours)
  }

  updatePrevGroupsHours(groups, day) {
    const [{ days, hours }, ...restGroups] = groups.reverse();
    const updatedGroups = [{ hours, days: [...days, day] }, ...restGroups];
    return [...updatedGroups].reverse()
  };

  sameHours(hours1, hours2) {
    return (hours1.startHr === hours2.startHr) && (hours1.endHr === hours2.endHr)
  };

  formatTime(timestamp) {
    const time = moment(timestamp, 'HH:mm:ss');

    if (time.minute()) {
      return time.format('h:mma');
    }

    return time.format('ha');
  }
};

export const groupAndFormatCommonHours = (operationalHours) => {
  const formattedHours = new GroupAndFormatHours(operationalHours);
  return formattedHours.call()
};
